import { CustomerDetails } from '../types/CustomerTypes';
import { mapCustomerToFormData } from '../mappers/CustomerMappers';
import { useGetCustomerQuery } from '@/common/infrastructure/gql/generated/schema';

export const useGetCustomer = (customerId?: number, skipQuery?: boolean) => {
  const skip = skipQuery || !customerId || isNaN(customerId); // Prevent API call if customerId is undefined or NaN

  const { data, loading, error } = useGetCustomerQuery({
    variables: { customerId: customerId! },
    skip
  });

  const customer = data?.customerDetails as CustomerDetails | null | undefined;
  const formData = mapCustomerToFormData(customer);

  return {
    customer: formData,
    customerDetails: customer,
    loading,
    error,
    deletable: customer?.deletable,
    availableCustomerTypes: customer?.availableCustomerTypes ?? [],
    availableSalesAgents: customer?.availableSalesAgents ?? [],
    availableTerms: customer?.availableTerms ?? [],
    availablePricingSchemes: customer?.availablePricingSchemes ?? [],
    availableSalesRegions: customer?.availableSalesRegions ?? [],
    availableAccountTypes: customer?.availableAccountTypes ?? []
  };
};
